<template>
  <div class="detail">
    <el-card>
            <div slot="header" class="clearfix">
                <el-button type="success" @click="update1">保存基本信息</el-button>
            </div>
            <div class="det">
        <div class="main">
          <div class="lable">
            <span>运单号:</span>
          </div>
            <div class="cent">
                <el-input placeholder="5-16位字符，禁止空格" 
                v-model="orderData.clientNo" type="text" maxlength="18" show-word-limit  
                v-no-space></el-input>
            </div>

        </div>
            </div>
            <div class="det">
        <div class="main">
          <div class="lable">
            <span>渠道方式:</span>
          </div>
          <div class="cent">
            <!--  -->
            <Channel :channels="orderData.channelId" :single="true" @getCty="getChannel"></Channel>
          </div>
        </div>
        <div class="main">
          <div class="lable">
            <span>报关方式:</span>
          </div>
          <div class="cent">
            <el-select v-model="orderData.declareType" clearable placeholder="请选择">
              <el-option
                v-for="item in declareType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="main">
            <div class="lable">
              <span>海运方式:</span>
            </div>
            <div class="cent">
              <el-cascader
                v-model="work"
                :options="freightMethod"
                :props="{ value: 'cid', label: 'name'}"
                @change="getMethod"
              ></el-cascader>
            </div>
          </div>
            </div>
            <div class="det">
        <div class="main">
          <div class="lable">
            <span>送货仓库:</span>
          </div>
          <div class="cent">
            <Patchplace :radio="true" :places="dispatchId" @getCty="getPlace($event)"></Patchplace>
          </div>
        </div>
        <div class="main">
          <div class="lable">
            <span>送货时间:</span>
          </div>
          <div class="cent">
            <el-date-picker
              @change="setTime"
              v-model="dispatchTime"
              type="datetime"
              placeholder="选择日期时间"
            ></el-date-picker>
          </div>
        </div>
        <div class="main">
          <div class="lable">
            <!-- <span>数据:</span> -->
          </div>
          <div class="cent">
           
          </div>
        </div>
        <div class="main">
          <div class="lable">
            <!-- <span>数据:</span> -->
          </div>
          <div class="cent">
          </div>
        </div>
            </div>
    </el-card>
    <el-card class="cards">
      <div slot="header" class="clearfix">
        <el-button type="success" @click="update2">保存产品</el-button>
        <el-button type="primary" @click="addList">添加已有产品</el-button>
        <el-dialog
          title="添加已有产品"
          :visible.sync="dialogVisible"
          center>
          <el-table
          :data="productData"
          @selection-change="selectData"
          ref="multipleTable"
          @row-click="handleRowClick"
          style="width: 100%">
            <el-table-column type="selection"></el-table-column>
            <el-table-column label="产品图" prop="picUrl">
                    <template slot-scope="scope">
                      <el-image :src="scope.row.picUrl" style="width:50px"></el-image>
                      </template>
                  </el-table-column>
            <el-table-column label="中文名称" prop="name"></el-table-column>
            <el-table-column label="英文名称" prop="ename"></el-table-column>
            <el-table-column label="型号" prop="model"></el-table-column>  
            <!-- <el-table-column label="国家" prop="country"></el-table-column> -->
            <!-- <el-table-column label="报关编码" prop="hscode"></el-table-column> -->
            <!-- <el-table-column label="清关编码" prop="gwcode"></el-table-column>
            <el-table-column label="税率" prop="taxRate"></el-table-column> -->
            <!-- <el-table-column label="材质" prop="material"></el-table-column> -->
            <el-table-column label="产品尺寸" prop="size"></el-table-column>
            <el-table-column label="产品标" prop="sku"></el-table-column>
            <el-table-column label="链接" prop="selleLink" width="120"></el-table-column>
            <!-- <el-table-column label="用途" prop="purpose"></el-table-column> -->
            <el-table-column label="品牌" prop="brand"></el-table-column>
          </el-table>
          <div class="block" style="margin-top:20px;text-align:center">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 40,60, 80,100]"
              :page-size="pagesize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            ></el-pagination>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="add">确 定</el-button>
          </span>
        </el-dialog>
        <el-button size="small" @click="uploads" type="primary">产品导入</el-button>
        <el-button size="small" @click="removes" type="primary">清空产品</el-button>
      </div>
      <!-- -->
      <div style="overflow:scroll;">
        <table class="gridtable">
          <thead>
            <tr>
              <th>
                <el-button class="th" type="text" size="mini" @click="insert" icon="el-icon-circle-plus">添加</el-button>
              </th>
              <th>
                <span class="th">图片</span>
              </th>
              <th>
                <span class="th">中文名</span>
              </th>
              <th>
                <span class="th">英文名</span>
              </th>
              <th>
                <span class="th">品牌</span>
              </th>
              <th>
                <span class="th">品牌类型</span>
              </th>
              <th>
                <span class="th">报关编码</span>
              </th>
              <th>
                <span class="th">清关编码</span>
              </th>
              <th>
                <span class="th">税率</span>
              </th>
              <th>
                <span class="th">材质</span>
              </th>
              <th>
                <span class="th">用途</span>
              </th>
              <th>
                <span class="th">带电情况</span>
              </th>
              <th>
                <span class="th">型号</span>
              </th>
              <th>
                <span class="th">件数</span>
              </th>
              <th>
                <span class="th">数量</span>
              </th>
              <th>
                <span class="th">单价(USD)</span>
              </th>
              <th>
                <span class="th">总价(USD)</span>
              </th>
              <th>
                <span class="th">客净重</span>
              </th>
              <th>
                <span class="th">客毛重</span>
              </th>
              <th>
                <span class="th">客体积</span>
              </th>
              <th>
                <span class="th">尺寸</span>
              </th>
              <th>
                <span class="th">唛头序号</span>
              </th>
              <th>
                <span class="th">产品标</span>
              </th>
              <th>
                <span class="th">链接</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user,index) in goodsData" :key="index">
              <td>
                <el-link type="danger" :underline="false" @click="remove(user,index)">删除</el-link>
              </td>

              <td>
                <!-- <img size="mini" class="odernum" :src="user.picUrl" /> -->
                <el-upload
                  class="upload-demo"
                  :action="UploadUrl()+'/file/upload'"
                  :on-success="handSuccess.bind(null, {'index':index})"
                  :on-remove="handRemove.bind(null, {'index':index})"
                  :file-list="fileList[index]"
                  list-type="picture"
                  :limit="1"
                  name="upload"
                >
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.name" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.ename" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.brand" />
              </td>
              <td>
                <el-select v-model="user.brandType" clearable placeholder="请选择" :popper-append-to-body="false">
                  <el-option
                    v-for="item in brandType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.hscode" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.gwcode" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.taxRate" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.material" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.purpose" />
              </td>
              <td>
                <el-select v-model="user.electrificationState" clearable placeholder="请选择" :popper-append-to-body="false">
                  <el-option
                    v-for="item in electrificationState"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.model" />
              </td>
              <td>
<!--                <el-input size="mini" class="odernum" v-model="user.ctn" />-->
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.ctn"></el-input-number>
              </td>
              <td>
<!--                <el-input size="mini" class="odernum" v-model="user.qty" @input="blur(index)" />-->
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.qty" @input="blur(index)"></el-input-number>
              </td>
              <td>
<!--                <el-input-->
<!--                  size="mini"-->
<!--                  class="odernum"-->
<!--                  v-model="user.unitValue"-->
<!--                  @input="blur(index)"-->
<!--                />-->
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.unitValue" @input="blur(index)"></el-input-number>
              </td>
              <td>
<!--                <el-input size="mini" class="odernum" v-model="user.totalValue" />-->
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.totalValue"></el-input-number>
              </td>
              <td>
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.nkg"></el-input-number>
              </td>
              <td>
<!--                <el-input size="mini" class="odernum" v-model="user.kg" />-->
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.kg"></el-input-number>
              </td>
              <td>
<!--                <el-input size="mini" class="odernum" v-model="user.cbm" />-->
                <el-input-number :controls="false" :precision="2" :min='0' :max="100000000" v-model="user.cbm"></el-input-number>
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.size" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.markNo" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.fnsku" />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.selleLink" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </el-card>
    <div class="cards">
      <el-card style="width:500px;float:left;">
        <div slot="header" class="clearfix">
          <h4 style="margin-left:15px">目的地</h4>
        </div>
        <div class="fba">
          <div class="chek">
            <el-radio-group v-model="orderData.shipmentType">
              <el-radio :label="'0'">fba地址</el-radio>
              <el-radio :label="'1'">私人地址</el-radio>
              <el-radio :label="'2'">三方仓</el-radio>
              <el-radio :label="'3'">留仓</el-radio>
              <el-radio :label="'4'">传统</el-radio>
              <el-radio :label="'5'">一件代发</el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="code" v-if="orderData.shipmentType=='0'">
              <div class="label">
                <span>Fbacode:</span>
              </div>
              <Fbacode :fbacodes="wareCode" @getCty="getFba($event)"></Fbacode>
            </div>
            <div class="code" v-if="orderData.shipmentType=='2'">
              <div class="label">
                <span>三方仓code:</span>
              </div>
              <Whcode :whcodes="whCode" @getCty="getWh($event)"></Whcode>
            </div>
            <div class="code" v-if="orderData.shipmentType=='3'">
              <div class="label">
                <span>留仓code:</span>
              </div>
              <el-select
                class="wareselect"
                v-model="whhold"
                filterable
                placeholder="请选择"
                style="width:375px;"
              >
                <el-option
                  v-for="(item,index) in whHoldData"
                  :key="index"
                  :label="item.lable"
                  :value="item.code"
                ></el-option>
              </el-select>
            </div>
            <div class="code" v-if="orderData.shipmentType=='4'">
              <div class="label">
                <span>目的港:</span>
              </div>
              <el-select
                class="wareselect"
                v-model="endPort"
                filterable
                placeholder="请选择"
                remote
                style="width:375px;"
              >
                <el-option
                  v-for="(item,index) in endPortList"
                  :key="index"
                  :label="item.portChinese +'/'+ item.portEnglish +'/'+ item.portFive"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>
            <div class="code" v-if="orderData.shipmentType=='5'">
              <div class="label">
                <span>一件代发:</span>
              </div>
              <el-select
                class="wareselect"
                v-model="wholesaleCode"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="(item,index) in wholesaleData"
                  :key="index"
                  :label="item.lable"
                  :value="item.code"
                ></el-option>
              </el-select>
            </div>
            <p
              v-if="orderData.shipmentType=='0'"
              style="margin-top:15px;text-align:left"
            >{{this.fbaAddress}}</p>
            <p
              v-if="orderData.shipmentType=='2'"
              style="margin-top:15px;text-align:left"
            >{{this.fbaAddress}}</p>
            <p
              v-if="orderData.shipmentType=='3'"
              style="margin-top:15px;text-align:left"
            >{{this.fbaAddress}}</p>
            <div class="country" v-if="orderData.shipmentType=='1'">
              <div class="flex">
                <div class="label">
                  <span>私人地址:</span>
                </div>
                <el-input type="textarea" :rows="2" placeholder="请输入地址" v-model="nfbaAddress"></el-input>
              </div>
              <div class="flex">
                <div class="label">
                  <span>国家:</span>
                </div>
                <Country :countrys="orderData.shipmentCountry" @getCty="getCoun($event)"></Country>
              </div>
              <div class="flex">
                <div class="label">
                  <span>收件人:</span>
                </div>
                <el-input v-model="orderData.shipmentContact" placeholder="请输入收件人"></el-input>
              </div>
              <div class="flex">
                <div class="label">
                  <span>电话:</span>
                </div>
                <el-input v-model="orderData.shipmentTel" placeholder="请输入电话"></el-input>
              </div>
              <div class="flex">
                <div class="label">
                  <span>州:</span>
                </div>
                <el-input v-model="orderData.shipmentState" placeholder="请输入州"></el-input>
              </div>
              <div class="flex">
                <div class="label">
                  <span>邮编:</span>
                </div>
                <el-input v-model="orderData.shipmentZip" placeholder="请输入邮编"></el-input>
              </div>
            </div>
          </div>
        </div>
      </el-card>
      <el-card style="width:750px">
        <div slot="header" class="clearfix">
          <h4 style="margin-left:15px">预约号</h4>
        </div>
        <table class="gridtable">
          <thead>
            <tr>
              <th>
                <el-button class="th" type="text" size="mini" @click="insertShip">添加</el-button>
              </th>
              <th>
                <span class="th">shipmentid</span>
              </th>
              <th>
                <span class="th">referenceid</span>
              </th>
              <th>
                <span class="th">件数</span>
              </th>
              <th>
                <span class="th">重量</span>
              </th>
              <th>
                <span class="th">体积</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(user,index) in shipmentData" :key="index">
              <td>
                <el-link type="danger" :underline="false" @click="removeShip(user,index)">删除</el-link>
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.shipmentid " />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.referenceid " />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.ctn " />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.kg " />
              </td>
              <td>
                <el-input size="mini" class="odernum" v-model="user.cbm " />
              </td>
            </tr>
          </tbody>
        </table>
      </el-card>
    </div>
    <el-dialog
      title="产品导入"
      :visible.sync="uploadDialog"
      width="400px"
      >
        <el-upload
          ref="upload"
          class="upload-demo"
          :action="uploadAction()"
          multiple
          drag
          :on-success="handProduct"
          :on-remove="handRemove"
          :limit="1"
          name="upload">
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
    </el-dialog>
  </div>
</template>

<script>
import httpApi from "@/http/api";
//引入时间函数
import { formatTimeToStr } from "@/util/toLocaleString.js";
import Channel from "../../components/select/Channel";
import Patchplace from "../../components/select/Patchplace";
import Fbacode from "../../components/select/Fbacode";
import Country from "../../components/select/Country";
import Whcode from "../../components/select/Whcode";
export default {
  name: "detail",
  props: {
    detail: String
  },
  components: {
    Channel, //渠道
    Patchplace, //送货地
    Fbacode,
    Country,
    Whcode
  },
  data() {
    return {
      markss: {},
      types: "",
      marks: "",
      suffix: "",
      isHasSuffix: false,
      serialNum: null,
      marksList: [],
      marksModel: "",
      responseDataUp: "",
      whHoldData:[],
      wholesaleData:[],
      endPort: "",
      endPortList: [],
      orderNo: this.detail,
      orderData: {},
      dispatchId: "",
      noList: false,
      shipmentType: [
        { label: "fba地址", value: "0" },
        { label: "私人地址", value: "1" },
        { label: "自提", value: "2" },
        { label: "留仓", value: "3" },
        { label: "传统", value: "4" }
      ],
      declareType: [
        { label: "买单 ", value: "0" },
        { label: "退税", value: "1" }
      ],
      sellerData: [],
      freightMethod: [
        {
          cid: "0",
          name: "拼柜"
        },
        {
          cid: "1",
          name: "整柜",
          children: []
        }
      ],
      work: [],
      dispatchTime: "",
      recStatus: "",
      orderStatus: "",
      uploadDialog: false,
      //产品
      goodsData: [],
      user: {
        name: "",
        ename: "",
        hscode: "",
        gwcode: "",
        taxRate: "",
        material: "",
        purpose: "",
        qty: "",
        unitValue: "",
        totalValue: "",
        ctn: "",
        nkg: "",
        kg: "",
        cbm: "",
        picUrl: "",
        brandType: "", //品牌类型
        exportBenefits: "", //出口享惠
        electrificationState: "",//带电情况
        markNo: "",
        fnsku: "",
        selleLink: "",
      },
      shipmentData: [],
      shipUser: {
        shipmentid: "",
        referenceid: "",
        ctn: "",
        kg: "",
        cbm: ""
      },
      fbaAddress: "",
      nfbaAddress: "",
      fileList: [],
      wareCode: "",
      whCode: "",
      whhold: "",
      wholesaleCode: "",
      brandType: [
        { label: "无品牌", value: "0" },
        { label: "境内自主品牌", value: "1" },
        { label: "境内收购品牌", value: "2" },
        { label: "境外品牌(贴牌生产)", value: "3" },
        { label: "境外品牌(其他)", value: "4" }
      ],
      exportBenefits: [
        { label: "出口货物在最终目的国（地区）不享受优惠关税", value: "0" },
        { label: "出口货物在最终目的国（地区）享受优惠关税", value: "1" },
        { label: "出口货物不能确定在最终目的国（地区）享受优惠关税", value: "2" }
      ],
      electrificationState: [
        { label: "否", value: "0" },
        { label: "只带电", value: "1" },
        { label: "只带磁", value: "2" },
        { label: "带电带磁", value: "3" }
      ],
      dialogVisible: false,
      dialogFormVisible3: false,
      productData: [], //产品列表
      currentPage: 1, //分页初始页
      pagesize: 20, //分页每页数据
      total: 0, //分页总数
      inputVal: "",
      selectDatas: "",
    };
  },
   directives: {
    'no-space': {
      inserted(el) {
        el.addEventListener('input', (e) => {
          e.target.value = e.target.value.replace(/\s+/g, '')
          e.target.dispatchEvent(new Event('input')) // 触发v-model更新
        })
      }
    }
  },
  methods: {
    //后台接口前缀
    UploadUrl() {
      return this.mApi
    },
    marksDownload(){
        this.dialogFormVisible3 = true;
    },    
    uploads(){
      this.uploadDialog = true;
    },
    uploadAction(){
      //return Api.portalSrc + "file/parseExcel/goods"
      return this.Api + "/file/parseExcel/goods";
    },
    getMar(e) {
      if (Array.isArray(e)){
        this.$message.warning("系统已更新，请按【ctrl+F5】刷新页面再使用唛头下载");
        return
      }
      this.markss = e
      this.marksModel = e.marksModel
      this.types= e.types
      this.suffix = e.suffix
      this.serialNum = e.serialNum
      this.isHasSuffix = e.isHasSuffix
    },
    handSuccess(obj, res) {
      this.fileList[obj.index] = [res.data];
      this.goodsData[obj.index].picUrl = this.fileList[obj.index][0].url;
    },
    handRemove(obj) {
      this.fileList[obj.index].splice(0, 1);
    },
    //详情
    initDetail() {
      let that = this;
      httpApi
        .findOrder( {
          params: { orderNo: that.$route.query.orderNo }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.orderData = res.data.data.findOrderResponse;
            console.log(this.orderData);
            that.dispatchId = Number(that.orderData.dispatchId)
            that.goodsData = res.data.data.findOrderGoodsResponseList;
            that.shipmentData = res.data.data.findOrderShipmentResponseList;
            //拿到产品图片
            for (let i = 0; i < that.goodsData.length; i++) {
              that.fileList[i] = [{ url: that.goodsData[i].picUrl }];
              if (that.fileList[i][0].url == "") {
                that.fileList[i] = [];
              }
            }
            //发票状态
            if (that.orderData.invoiceStatus == "0") {
              that.orderData.invoiceStatus = "未确认";
            } else {
              that.orderData.invoiceStatus = "确认";
            }
            //数据状态
            if (that.orderData.dataStatus == "0") {
              that.orderData.dataStatus = "未确认";
            } else {
              that.orderData.dataStatus = "确认";
            }
            //付款状态
            if (that.orderData.recStatus == 0) {
              that.orderData.recStatus = "未收款";
            } else {
              that.orderData.recStatus = "已收款";
            }
            //订单状态
            if (that.orderData.orderStatus == 0) {
              that.orderData.orderStatus = "进行中";
            } else if (that.orderData.orderStatus == 1) {
              that.orderData.orderStatus = "异常";
            } else if (that.orderData.orderStatus == 2) {
              that.orderData.orderStatus = "已完成";
            } else {
              that.orderData.orderStatus = "已取消 ";
            }
            if (that.orderData.freightMethod == "0") {
              let arr = ["0"];
              that.work = arr;
            } else {
              let arr = ["1", that.orderData.containerType];
              that.work = arr;
            }
            //送货时间
            that.dispatchTime = new Date(that.orderData.dispatchTime) * 1000;
            //fba ,非fba
            if (that.orderData.shipmentType == "1") {
              that.nfbaAddress = that.orderData.shipmentAddress;
              that.fbaAddress = "";
            } else if (that.orderData.shipmentType == "0") {
              that.fbaAddress = that.orderData.shipmentAddress;
              that.nfbaAddress = "";
              that.wareCode = that.orderData.shipmentCode;
            } else if (that.orderData.shipmentType == "2") {
              that.fbaAddress = that.orderData.shipmentAddress;
              that.nfbaAddress = "";
              that.whCode = that.orderData.shipmentCode;
            } else if (that.orderData.shipmentType == "4") {
              that.endPort = Number(that.orderData.shipmentCode);
            } else if (that.orderData.shipmentType == "5") {
              that.fbaAddress = that.orderData.shipmentAddress;
              that.nfbaAddress = "";
              that.wholesaleCode = that.orderData.shipmentCode;
            } else {
              that.fbaAddress = that.orderData.shipmentAddress;
              that.nfbaAddress = "";
              that.whhold = that.orderData.shipmentCode;
            }
          } else {
            that.$message.error(res.data.message);
          }
        });

        httpApi
          .listParams( {
            params: {
              type: "sys_port",
              enable:"1"
            }
          })
          .then(res => {
            if (res.data.code == "ok") {
              that.endPortList = res.data.data;
            }
          });
    },

    whHoldList() {
      httpApi.listParams({ params: { type: "sys_wh_hold",enable:"1" } }).then(res => {
        if (res.data.code == "ok") {
          let whHoldData = [];
          let wholesaleData = [];
          // that.addressInfo = that.whHoldData[0].address;
          let resData = res.data.data;
          for (let i in resData) {
            resData[i].lable =
            resData[i].code + " " + resData[i].zip + " " + resData[i].serves;
            if(resData[i].serves.includes('自提')||resData[i].serves.includes('留仓')){
              whHoldData.push(resData[i]);
            }
            if(resData[i].serves.includes('一件代发')){
              wholesaleData.push(resData[i]);
            }
          }
          this.whHoldData = whHoldData;
          this.wholesaleData = wholesaleData;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    getCourier(e) {
      this.orderData.courierNo = e;
    },
    //渠道
    getChannel(e) {
      this.orderData.channelId = e;
    },
    //送货地
    getPlace(e) {
      this.orderData.dispatchId = e;
    },
    //整柜
    getMethod(val) {
      this.work = val;
    },
    //整柜类型
    initContainer() {
      httpApi
        .listParams({ params: { type: "sys_container_type",enable:"1" } })
        .then(res => {
          if (res.data.code == "ok") {
            this.freightMethod[1].children = res.data.data;
            for (let i in this.freightMethod[1].children) {
              this.freightMethod[1].children[
                i
              ].cid = this.freightMethod[1].children[i].name;
            }
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    //送货时间
    setTime() {
      this.orderData.dispatchTime =
        new Date(this.dispatchTime).getTime() / 1000;
    },
    // 保存详情1
    update1() {
      let that = this;
      httpApi
        .update1({
          channelId: that.orderData.channelId,
          clientNo: that.orderData.clientNo,
          containerType: that.work[1],
          declareType: that.orderData.declareType,
          dispatchId: that.orderData.dispatchId,
          dispatchTime: that.orderData.dispatchTime,
          courierNo: that.orderData.courierNo,
          enLogno: that.orderData.enLogno,
          orderingNo: that.orderData.orderingNo,
          freightMethod: that.work[0],
          orderNo: that.orderData.orderNo,
          remark: that.orderData.remark,
          sellerId: that.orderData.sellerId,
          userRemark: that.orderData.userRemark,
          whNo: that.orderData.whNo,
          cityId: that.orderData.cityId,
          followId: that.orderData.followId,
          ctn: that.orderData.ctn
        })
        .then(res => {
          if (res.data.code == "ok") {
            if(that.orderData.enLogno!=""&&that.orderData.courierNo!=""){
              httpApi
                .setCreate({
                  params:{
                    number: that.orderData.enLogno,
                    courierCode: that.orderData.courierNo
                  }
                })
            }
            that.$message.success("修改成功");
            that.initDetail();
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    //品牌
    insert() {
      this.province
      this.goodsData.push(JSON.parse(JSON.stringify(this.user)));
    },
    remove(user, index) {
      this.$message({
        type: "success",
        message: "删除成功!"
      });
      this.goodsData.splice(index, 1);
      this.fileList.splice(index, 1);
    },
    removes() {
      this.$message({
        type: "success",
        message: "清空成功!"
      });
      for(var i=0;0<this.goodsData.length;i++){
      this.goodsData.splice(0, 1);
      this.fileList.splice(0, 1);
      }
    },
    blur(index) {
      var num = 0;
      num = (
        Number(this.goodsData[index].qty) *
        Number(this.goodsData[index].unitValue)
      ).toFixed(2);
      this.goodsData[index].totalValue = JSON.parse(JSON.stringify(num));
    },
    getApi(){
      return this.Api + "/file/goodsTemplate";
    },
    apiAction(){
      return this.Api + "/file/parseExcel/shipment"
    },
    async handShipmentId(response,file,fileList){

      if(response.message !== '成功'){
        this.$message.error(response.message);
      }else{

        let shipmentList = response.data
        let order_userList = [];
        shipmentList.forEach(v=>{
          let order_userItem =  JSON.parse(JSON.stringify(v))
          order_userItem.shipmentid = v[0];
          order_userItem.referenceid = v[1]
          order_userItem.ctn = v[2]
          order_userItem.kg = v[3]
          order_userItem.cbm = v[4]
          order_userList.push(JSON.parse(JSON.stringify(order_userItem)))
        });

        this.shipmentData = order_userList

      }

    },
    //预约号
    insertShip() {
      this.shipmentData.push(JSON.parse(JSON.stringify(this.shipUser)));
    },
    removeShip(user, index) {
      this.$message({
        type: "success",
        message: "删除成功!"
      });
      this.shipmentData.splice(index, 1);
    },
    // Fbacode
    getFba(e) {
      this.wareCode = e;
    },
    //自提
    getWh(e) {
      this.whCode = e;
    },
    //留仓
    getWhhold(e) {
      this.whhold = e;
    },
    //一件代发
    getWhhold2(e) {
      this.wholesaleCode = e;
    },
    //country
    getCoun(e) {
      this.orderData.shipmentCountry = e;
    },
    // 保存2
    update2() {
      let that = this;
      let code = "";
      if (that.orderData.shipmentType == "1") {
        that.orderData.shipmentAddress = that.nfbaAddress;
      } else if (that.orderData.shipmentType == "0") {
        // that.orderData.shipmentAddress = that.fbaAddress;
        code = that.wareCode;
      } else if(that.orderData.shipmentType == "2") {
        // that.orderData.shipmentAddress = that.fbaAddress;
        code = that.whCode;
      }else if(that.orderData.shipmentType == "4") {
        // that.orderData.shipmentAddress = that.fbaAddress;
        code = that.endPort;
      }else if(that.orderData.shipmentType == "5") {
        // that.orderData.shipmentAddress = that.fbaAddress;
        code = that.wholesaleCode;
      }else{
        // that.orderData.shipmentAddress = that.fbaAddress;
        code = that.whhold;
      }
      httpApi
        .update2({
          goodsList: that.goodsData,
          orderNo: that.orderData.orderNo,
          shipmentAddress: that.orderData.shipmentAddress,
          shipmentCode: code,
          shipmentContact: that.orderData.shipmentContact,
          shipmentCountry: that.orderData.shipmentCountry,
          shipmentList: that.shipmentData,
          shipmentState: that.orderData.shipmentState,
          shipmentTel: that.orderData.shipmentTel,
          shipmentType: that.orderData.shipmentType,
          shipmentState: that.orderData.shipmentState,
          shipmentZip: that.orderData.shipmentZip
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.$message.success("修改成功");
            if(that.responseDataUp!=null&&that.responseDataUp!=undefined&&that.responseDataUp!=""){
              that.setFile(that.responseDataUp);
            }
            that.initDetail();
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    
    setFile(response) {
      let that = this;
      let arr = response;
      httpApi
        .addFile({
          ext: arr.ext,
          name: arr.filename,
          orderNo: that.orderNo,
          size: arr.size,
          type: "5",
          url: arr.url
        })
        .then(res=>{
          if (res.data.code == "ok") {
            that.responseDataUp = "";
          }
        });
    },
    async handProduct(response, file, fileList){
      if(response.message !== "成功"){
        this.$message.error(response.message);
      }
      this.uploadDialog = false;
      // this.goodsData = ;
      this.responseDataUp = response.data.upload;
      var goods = response.data.list;
      var goodsList = [];
      for (var i = 0; i < goods.length; i++) {
        var g = {};
        var obj = goods[i];
        
        //有品名添加
        if(obj[1]!=""&&obj[1]!=null&&obj[1]!=undefined){
          if(obj[7]=="否"||obj[7]=="只带电"||obj[7]=="只带磁"||obj[7]=="带电带磁"){
            g.electrificationState = obj[7];
          }else{
            await this.$message.error("带电带磁格式错误");
            g.electrificationState = "";
          };
          if(obj[9]=="无品牌"||obj[9]=="境内自主品牌"||obj[9]=="境内收购品牌"||obj[9]=="境外品牌(贴牌生产)"||obj[9]=="境外品牌(其他)"){
            g.brandType = obj[9];
          }else{
            await this.$message.error("品牌类型格式错误,括号需要用小写");
            g.brandType = "";
          };
          g.name = obj[0];
          g.ename = obj[1];
          g.material = obj[2];
          g.purpose = obj[3];
          g.hscode = obj[4];
          g.gwcode = obj[5];
          g.taxRate = obj[6];
          g.brand = obj[8];
          g.model = obj[10];
          g.ctn =obj[11];
          g.qty = obj[12];
          g.unitValue = obj[13];
          g.totalValue = obj[14];
          g.size = obj[15] + "*" + obj[16] + "*" + obj[17];
          g.nkg = obj[18];
          g.kg = obj[19];
          g.cbm = obj[20];
          g.picUrl = obj.picUrl;
          g.markNo = obj[25];
          g.fnsku = obj[26];
          g.selleLink = obj[27];
          // goodsList.push(g);
          this.goodsData.push(g);
        }
        //有预约号添加
        if(obj[22]!=""&&obj[22]!=null&&obj[22]!=undefined){
          var s = {};
          s.shipmentid = obj[22];
          s.referenceid = obj[23];
          s.ctn = 0;
          s.kg = 0.00;
          s.cbm = 0.00;
          this.shipmentData.push(s);
        }

        //将图片展示出来
        if (this.goodsData[this.goodsData.length-1].picUrl){

          this.fileList[this.goodsData.length-1] = [{url: this.goodsData[this.goodsData.length-1].picUrl}]
        }
      }

      this.$refs.upload.clearFiles();
      this.analysis();
    },
    analysis(){
      for (let i in  this.goodsData) {
        let numBT =  this.goodsData[i].brandType;//品牌类型解析
        switch(numBT){
          case "无品牌":
            this.goodsData[i].brandType = "0"
            break;
          case "境内自主品牌":
            this.goodsData[i].brandType = "1"
            break;
          case "境内收购品牌":
            this.goodsData[i].brandType = "2"
            break;
          case "境外品牌(贴牌生产)":
            this.goodsData[i].brandType = "3"
            break;
          case "境外品牌(其他)":
            this.goodsData[i].brandType = "4"
            break;
        }
        let numES =  this.goodsData[i].electrificationState;//带电带磁解析
        switch(numES){
          case "否":
            this.goodsData[i].electrificationState = "0"
            break;
          case "只带电":
            this.goodsData[i].electrificationState = "1"
            break;
          case "只带磁":
            this.goodsData[i].electrificationState = "2"
            break;
          case "带电带磁":
            this.goodsData[i].electrificationState = "3"
            break;
        }
      }
    },
    uploadProduct(){
      this.$refs.upload.clearFiles();
    },
    //添加已有产品
    addList() {
      this.dialogVisible = true;
      let that = this;
      httpApi
        .queryProduct({
          params: {
            page: that.currentPage,
            rows: that.pagesize,
            userId: that.orderData.userId,
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.productData = res.data.data.rows;
            that.total = res.data.data.total;
          } else {
            that.$message.error(res.data.message);
          }
        });
    },
    selectData(val) {
      this.selectDatas = val
    },
    add(){
      for (const i in this.selectDatas) {
        let obj = {};
        obj["name"] = this.selectDatas[i].name;
        obj["ename"] = this.selectDatas[i].ename;
        obj["material"] = this.selectDatas[i].material;
        obj["purpose"] = this.selectDatas[i].purpose;
        obj["hscode"] = this.selectDatas[i].hscode;
        obj["gwcode"] = this.selectDatas[i].gwcode;
        obj["taxRate"] = this.selectDatas[i].taxRate;
        obj["electrificationState"] = this.selectDatas[i].electrificationState;
        obj["brand"] = this.selectDatas[i].brand;
        obj["brandType"] = this.selectDatas[i].brandType;
        obj["model"] = this.selectDatas[i].model;
        obj["ctn"] = 1;
        obj["qty"] = 1;
        obj["unitValue"] = "";
        obj["totalValue"] = "";
        obj["nkg"] = "";
        obj["kg"] = "";
        obj["size"] = this.selectDatas[i].size;
        obj["cbm"] = "";
        obj["picUrl"] = this.selectDatas[i].picUrl;
        this.goodsData.push(obj)
        //将图片展示出来
        if (this.goodsData[this.goodsData.length-1].picUrl){

          this.fileList[this.goodsData.length-1] = [{url: this.goodsData[this.goodsData.length-1].picUrl}]
        }
      }
      this.analysis();
      this.dialogVisible = false;
    },
    //点击行选中
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    handleSizeChange: function(size) {
      this.pagesize = size;
      this.currentPage = 1;
      this.queryProduct();
    },
    handleCurrentChange: function(currentPage) {
      this.currentPage = currentPage;
      this.queryProduct();
    },
  },
  created() {
    this.initContainer();
    this.whHoldList();
    this.initDetail();
  },
  watch: {
    detail(val) {
      this.orderNo = val;
    }
  },
  filters: {
    formatDate: function(time) {
      if (time != null && time != "") {
        var date = new Date(time * 1000);
        // eslint-disable-next-line no-undef
        return formatTimeToStr(date, "yyyy-MM-dd hh:mm:ss");
      } else {
        return "";
      }
    }
  }
};
</script>

<style lang="less" scoped>
.cards {
  margin-top: 20px;
}
.cards:last-child {
  width: 1200px;
  display: flex;
  justify-content: space-between;
}

.marks-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 40px; /* 可根据实际内容调整 */
}

.det {
  margin-top: 20px;
  display: flex;
  .main {
    width: 220px;
    display: flex;
    line-height: 32px;
    margin-left: 15px;
    .lable {
      width: 60px;
      font-weight: bold;
      text-align: right;
    }
    .cent {
      width: 150px;
      text-align: left;
      margin-left: 10px;
      .el-date-editor {
        width: 150px;
      }
    }
  }
  .txt {
    width: 360px;
    display: flex;
    margin-left: 15px;
    .lable {
      width: 60px;
      font-weight: bold;
      text-align: right;
    }
    .cent {
      width: 300px;
      text-align: left;
      margin-left: 10px;
    }
  }
}
table.gridtable {
  font-family: verdana, arial, sans-serif;
  font-size: 11px;
  color: #333333;
  border-width: 1px;
  border-color: #666666;
  border-collapse: collapse;
  margin-top: 20px;
  .el-input {
    width: 100px;
    /deep/ .el-input__inner {
      text-align: center !important;
      padding: 0;
    }
  }
}
table.gridtable th {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ddd;
  background-color: #ffffff;
  .th {
    width: 100px;
    display: inline-block;
  }
}
table.gridtable td {
  border-width: 1px;
  padding: 8px;
  border-style: solid;
  border-color: #ddd;
  background-color: #ffffff;
}
.fba {
  margin-top: 20px;
  .chek {
    text-align: left;
  }
  .code {
    width: 250px;
    margin-top: 25px;
    display: flex;
    .label {
      width: 80px;
      font-weight: bold;
      text-align: right;
    }
    .el-select {
      width: 150px;
      margin-left: 10px;
    }
    .el-textarea {
      margin-top: 15px;
      .el-textarea__inner {
        width: 150px !important;
      }
    }
  }
  .country {
    width: 250px;
    margin-top: 25px;
    .flex {
      display: flex;
      margin-top: 10px;
      /deep/.label {
        width: 80px;
        font-weight: bold;
        text-align: right;
      }
      .el-textarea,
      .el-select,
      .el-input {
        width: 150px;
        margin-left: 10px;
      }
    }
  }
}
/deep/.el-upload-list__item-name {
  display: none !important;
}
</style>